const styles = {
  container: { padding: "20px" },
  card: { padding: "1.5rem", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", borderRadius: "1rem", background: "#f8fafc", marginBottom: "1.5rem" },
  flexHeader: { display: "flex", alignItems: "center", justifyContent: "space-between" },
  productTitle: { margin: 0, display: "flex", alignItems: "center" },
  icon: { marginRight: "0.5em" },
  badge: {
    background: "#d1fae5",
    color: "#059669",
    fontWeight: "bold",
    fontSize: "0.85em",
    padding: "0.25em 0.75em",
    borderRadius: "1em",
    letterSpacing: "1px",
    marginLeft: "1em",
    boxShadow: "0 1px 4px rgba(16,185,129,0.10)"
  }
};

const Products = () => {
  return (
    <div style={styles.container}>
      <h2 className="text-center mb-4">Our Products</h2>
      <div style={styles.card}>
        <div style={styles.flexHeader}>
          <h3 style={styles.productTitle}>
            <span role="img" aria-label="microphone" style={styles.icon}>🎤</span>
            VoiceLoop AI Agent
          </h3>
          <span style={styles.badge}>NEW</span>
        </div>
        <p>
          VoiceLoop is your AI-powered transcription assistant. Record or upload audio, and VoiceLoop will turn your spoken ideas into clear, organized text—perfect for notes, blog posts, or social media. Your audio is processed securely and never stored after transcription.
        </p>
        <p>
          👉 <a href="/voice-loop">Try VoiceLoop</a>
        </p>
      </div>
      <div style={styles.card}>
        <h3 style={styles.productTitle}>
          <span role="img" aria-label="home" style={styles.icon}>🏠</span>
          iHtrack App
        </h3>
        <p>
          iHtrack is your ultimate home inventory and organization companion. Effortlessly manage your home items, track inventory levels, and organize by categories like groceries, electronics, books, and more.
        </p>
        <p>
          👉 <a href="https://apps.apple.com/us/app/ihtrack/id6745040614" target="_blank" rel="noopener noreferrer">Download iHtrack on the App Store</a>
        </p>
      </div>
    </div>
  );
};

export default Products;
